export default {"src":"/_next/static/media/ENPH.82f58d24.svg","height":18,"width":18};